import { render, staticRenderFns } from "./ClaimGladiatorModal.vue?vue&type=template&id=1b54347e&"
import script from "./ClaimGladiatorModal.vue?vue&type=script&lang=ts&"
export * from "./ClaimGladiatorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports